<!--
     <FieldIndicatorRiskInterpretation />
-->

<template>
  <div class="firi-cont">
    <div class="firi-color" :style="'background-color:' + color "></div>
    <div
      class="firi-label"
      :style="'border-color:' + color "
    >
      {{ label }}
    </div>
  </div>
</template>


<style lang="scss">
 .firi-cont {
   height: 30px;
   width: 120px;
   border-radius: 5px;
   background-color: transparent;
   display: flex;
   flex-wrap: nowrap;
   flex-direction: row;
 }

 .firi-color {
   width: 40px;
   height: 100%;
   border-radius: 5px 0px 0px 5px;
 }

 .firi-label {
   height: 100%;
   width: 100%;
   font-size: 14px;
   padding: 2px 4px 2px 4px;
   border-style: solid;
   border-width: 3px;
   border-radius: 0px 5px 5px 0px;
   display: flex;
   align-items: center;
 }
</style>


<script>
 export default {
   name: 'FieldIndicatorRiskInterpretation',
   
   props: ['field'],
   
   computed: {
     label() {
       return '' + this.field.label || '';
     },

     color() {
       return '' + this.field.color || 'transparent';
     },
   },
 };
</script>
